'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useCallback, useEffect, useState } from 'react';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';

// Lazy load the actual Intercom component
const IntercomClient = dynamic(() => import('./IntercomClient'), {
    ssr: false,
    loading: () => null,
});

// Facade component that loads Intercom only when needed
export default function IntercomLazy() {
    const [shouldLoad, setShouldLoad] = useState(false);
    const pathname = usePathname();

    // Pages where Intercom should be visible by default
    const intercomPages = ['/contact', '/visit-us/creamery'];
    const isIntercomPage = intercomPages.includes(pathname);

    // Load Intercom when:
    // 1. User is on a page where it should be visible
    // 2. User interacts with the page (scroll, click, touch)
    // 3. After a delay for non-critical loading
    const loadIntercom = useCallback(() => {
        if (!shouldLoad) {
            setShouldLoad(true);
        }
    }, [shouldLoad]);

    // Load immediately on Intercom pages
    useEffect(() => {
        if (isIntercomPage) {
            loadIntercom();
        }
    }, [isIntercomPage, loadIntercom]);

    // Load on user interaction (scroll, click, touch, keydown)
    useEffect(() => {
        if (shouldLoad) return;

        const handleInteraction = () => {
            loadIntercom();
        };

        const events = ['scroll', 'click', 'touchstart', 'keydown'];
        events.forEach(event => {
            document.addEventListener(event, handleInteraction, {
                once: true,
                passive: true,
            });
        });

        return () => {
            events.forEach(event => {
                document.removeEventListener(event, handleInteraction);
            });
        };
    }, [shouldLoad, loadIntercom]);

    // // Fallback: Load after 3 seconds if no interaction
    // useEffect(() => {
    //     if (shouldLoad) return;

    //     const timer = setTimeout(() => {
    //         loadIntercom();
    //     }, 3000);

    //     return () => clearTimeout(timer);
    // }, [shouldLoad, loadIntercom]);

    // Global function to manually trigger Intercom loading
    useEffect(() => {
        window.loadIntercom = loadIntercom;
        return () => {
            delete window.loadIntercom;
        };
    }, [loadIntercom]);

    return shouldLoad ? (
        <IntercomClient isIntercomPage={isIntercomPage} />
    ) : null;
}

// Export function to manually show Intercom (for contact forms, etc.)
export const showIntercom = () => {
    if (window.loadIntercom) {
        window.loadIntercom();
    }

    // Wait a bit for Intercom to load, then show it
    setTimeout(() => {
        if (window.Intercom) {
            window.Intercom('show');
        }
    }, 100);
};
